/* Nyrée Joyas — interacciones (vanilla) */
(function () {
  'use strict';
  document.documentElement.classList.add('ny-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ny-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('ny-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('ny-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: nada puede quedarse invisible
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('ny-visible'); });
    }, 2800);
  }

  /* Cronómetro de urgencia (persistente por visitante) */
  function initCountdown() {
    document.querySelectorAll('[data-ny-countdown]').forEach(function (el) {
      var hours = parseFloat(el.getAttribute('data-horas')) || 12;
      var span = hours * 3600 * 1000;
      var key = 'ny_cd_' + Math.round(hours);
      var end = parseInt(localStorage.getItem(key), 10);
      var now = Date.now();
      if (!end || isNaN(end) || end < now) { end = now + span; try { localStorage.setItem(key, end); } catch (e) {} }
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { end = Date.now() + span; try { localStorage.setItem(key, end); } catch (e) {} diff = span; }
        var t = Math.floor(diff / 1000);
        if (h) h.textContent = pad(Math.floor(t / 3600));
        if (m) m.textContent = pad(Math.floor((t % 3600) / 60));
        if (s) s.textContent = pad(t % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function boot() { initReveal(); initCountdown(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
